var React = require('react');

function CheckmarkSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.999653 4.65269L4.45905 8.11209L11.1117 1.4594","stroke":"currentColor","strokeWidth":"1.50533"}));
}

CheckmarkSmall.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = CheckmarkSmall;

CheckmarkSmall.default = CheckmarkSmall;
